import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M56 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C27.834 7 5 29.834 5 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#7B8493" d="M94.5 109a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path fill="#ACB8C3" d="M101.5 40a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M10.566 76a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V77.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M2 84.566a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H3.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      fillRule="evenodd"
      d="M102 91a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0M21.75 20A4.25 4.25 0 0 1 26 15.75h60A4.25 4.25 0 0 1 90.25 20v76a4.25 4.25 0 0 1-4.25 4.25H26A4.25 4.25 0 0 1 21.75 96zm4.5.25v75.5h59.5v-75.5z"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M80 89.5a1 1 0 0 1-1 1H33a1 1 0 0 1-1-1V87a1 1 0 0 1 1-1h46a1 1 0 0 1 1 1z"
      clipRule="evenodd"
    />
    <rect width={8} height={23} x={45.5} y={60} fill="#C7D0D9" rx={1} />
    <rect width={8} height={19} x={58} y={64} fill="#ACB8C3" rx={1} />
    <rect width={8} height={16} x={33} y={67} fill="#ACB8C3" rx={1} />
    <rect width={8} height={29} x={70.5} y={54} fill="#C7D0D9" rx={1} />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M61.75 35A2.25 2.25 0 0 1 64 32.75h12a2.25 2.25 0 0 1 0 4.5H64A2.25 2.25 0 0 1 61.75 35M61.75 43A2.25 2.25 0 0 1 64 40.75h8a2.25 2.25 0 0 1 0 4.5h-8A2.25 2.25 0 0 1 61.75 43"
      clipRule="evenodd"
    />
    <path fill="#7B8493" d="M56 39a12 12 0 0 0-12-12v12z" />
    <path fill="#C7D0D9" d="M44 27a12 12 0 0 0-8.485 20.485L44 39z" />
    <path fill="#ACB8C3" d="M35.515 47.485A12 12 0 0 0 56 39H44z" />
  </svg>
);
const SvgEnrichedIconReportsGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconReportsGreyscale);
export default Memo;
